import React from "react";
import { Modal, Paragraph } from "@tvg/design-system";
import { getTrackRulesModalTitleMessage } from "@tvg/sh-lib-my-bets/redux/selectors";
import { useSelector } from "react-redux";
import type { Props } from "./types";

const TrackRulesModal = (props: Props) => {
  const { isOpen, onClose, subtitle, messages } = props;
  const qaLabel = "track-rules-modal";

  const trackRulesModalTitle = useSelector(getTrackRulesModalTitleMessage);

  return (
    <Modal
      qaLabel={qaLabel}
      title={trackRulesModalTitle}
      isOpen={isOpen}
      onAfterClose={onClose}
      subtitle={subtitle}
      titlePosition="start"
      isTrackRulesModal
      hasBackgroundModal
    >
      <>
        {messages.map((message, index) => (
          <Paragraph
            key={message.toString()}
            qaLabel={`${qaLabel}-message-${index}}`}
            color="grey.800"
          >
            {message}
          </Paragraph>
        ))}
      </>
    </Modal>
  );
};

export default TrackRulesModal;
